import React, { FC, useCallback, useLayoutEffect, useState, useRef } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { Button } from '@wmgtech/legato'

import { ProjectSuccessModal } from 'modulesCommon/FeedbackModal/components'
import { ISuccessModalProps } from './SuccessModal.props'
import styles from './success-modal.module.scss'

const SuccessModal: FC<ISuccessModalProps> = ({ onFeedback }) => {
  const location = useLocation()
  const navigate = useNavigate()

  const feedbackInfo = useRef<[string, string]>()

  const [isOpen, setModal] = useState<boolean>(location.state?.isNew === true)
  const [isLocalized] = useState<boolean>(location.state?.isLocalized === true)

  const onClose = useCallback(() => {
    setModal(false)
  }, [])

  const handleFeedback = useCallback(() => {
    if (feedbackInfo.current) {
      onFeedback(feedbackInfo.current)
      setModal(false)
    }
  }, [onFeedback])

  useLayoutEffect(() => {
    if (location.state?.isNew || location.state?.isLocalized) {
      if (location.state.artistName && location.state.projectName) {
        feedbackInfo.current = [location.state.artistName, location.state.projectName]
      }
      navigate(location, { replace: true, state: {} })
    }
  })

  return (
    <ProjectSuccessModal
      isOpen={isOpen}
      onCloseHandler={onClose}
      body={
        isLocalized === true
          ? 'You successfully activated this project to your Storybox Zone. Thank you for taking the time on this project. We hope it is a great success!'
          : 'Your project has been successfully added to your Zone in Storybox. Thank you for taking the time on your project. We hope they are a great success!'
      }
      footer={
        <div className={styles.btnGroup}>
          {feedbackInfo.current?.length ? (
            <Button
              onClick={handleFeedback}
              label="Give Feedback"
              colorType="secondary-black"
              containerStyle="outline"
              size="md"
            />
          ) : null}
          <Button onClick={onClose} label="Close" colorType="secondary-black" containerStyle="solid" size="md" />
        </div>
      }
    />
  )
}

export default SuccessModal
